// extracted by mini-css-extract-plugin
module.exports = {"rightContent":"styles_rightContent__25kDL","table":"styles_table__1ahzW","gameBoost42":"styles_gameBoost42__2OPSM","row":"styles_row__2OQmq","deleted":"styles_deleted__3IvCe"};